import React from "react";
import { Modal } from "antd";

import CustomButton from "../CustomButton";
import phone from "../../assest/preview pic.png";

const CampaignMessagepreview = ({ visible, onClose, selectedtemplate }) => {
  const cancel = () => {
    onClose();
  };

  return (
    <Modal
      className="importusermodal"
      title=""
      open={visible}
      onCancel={onClose}
      centered
      footer={[]}
    >
      <h1>Message Preview</h1>
      
      <p>{selectedtemplate?.name}</p>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div style={{ position: "relative" }}>
          <img className="w-96" alt="" src={phone} />
          <p className="insideshowmessage max-h-96 overflow-auto">{selectedtemplate?.message}</p>
        </div>
      </div>

      <CustomButton
        style={{ margin: "auto", display: "flex" }}
        width={"50%"}
        onClick={cancel}
        text={"Continue"}
      />
    </Modal>
  );
};

export default CampaignMessagepreview;
